<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Extraction des dossiers ayant une pj JA N-1</strong>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="dateRevenu"
              :label-cols="6"
              :horizontal="true">
              <template slot="label"><b>Avis d'imposition sur les revenus de :</b></template>
              <b-form-input class="custom-input-reduit"
                            type="integer"
                            id="dateRevenu"
                            @paste="onPaste($event, 'debut')"
                            v-model="dateRevenu"
                            :class="{hasError: errors.dateRevenu !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.date_debut }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-button class="mt-2 mb-1 mr-1" variant="info" @click="generateExcel">Génerer</b-button>
        </div>

      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import { formatDate } from "@/utils/communHelper";
  import { downloadFile, isEmpty } from '@/utils/fileHelper';
  import moment from 'moment';

  export default {
    name: "ExtractionDossierJAN1",
    data() {
      return {
        dateRevenu: null,
        errors: {
          dateRevenu: '',
        }
      }
    },
    created() {
      // this.$axios.defaults.baseURL = getBaseUrl();
      // this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      // this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      // this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      generateExcel() {
        let self = this;
        if(this.validateForm()) {
          let data = {
            dateRevenu: this.dateRevenu
          };
          let filename = 'extraction_dossier_ja_n1_' + formatDate(this.dateRevenu);

          this.$store.commit('IS_LOADING', true);
          if (!isEmpty(process.env.VUE_APP_MIDDLE_EXTRACT_URL)) {
            this.$axios.defaults.baseURL = process.env.VUE_APP_MIDDLE_EXTRACT_URL;
          }
          this.$axios
            .post(`/espaceGestion/extractions/extraction-dossier-ja-n1`, data, {responseType: "arraybuffer"})
            .then(response => {
              this.$store.commit('IS_LOADING', false);
              
              downloadFile(response, filename, 'csv', '_BLANK')
            })
            .catch(function(error){
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la génération du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 6000})
            });
        }
      },
      validateForm() {
        let valid = true;
        if (this.dateRevenu === '' || this.dateRevenu === null) {
          this.errors.dateRevenu = 'La date de revenu fiscal est obligatoire';
          valid = false;
        }
        return valid;
      },
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .center {
    text-align: center;
  }
</style>
